var map = {
	"./1INCH.png": "065c",
	"./3077.png": "fb0b",
	"./AAVE.png": "8469",
	"./ADA.png": "b038",
	"./ALGORAND.png": "6969",
	"./ATOM.png": "cd26",
	"./AVALANCHE.png": "b3d4",
	"./AVAX.png": "1bff",
	"./BCH.png": "267a",
	"./BINANCE.png": "272a",
	"./BINANCE_COIN.png": "a300",
	"./BINANCE_COIN_BSC.png": "7f87",
	"./BITCOIN.png": "d91f",
	"./BITCOIN_CASH.png": "e5eb",
	"./BNB.png": "7f84",
	"./BTC.png": "c548",
	"./CAKE.png": "a436",
	"./CELO.png": "44e9",
	"./CHAIN_LINK.png": "6ecb",
	"./CLASSIC_ETHEREUM.png": "d3c4",
	"./COMP.png": "2a55",
	"./COMPOUND.png": "3cdf",
	"./COSMOS.png": "5cb7",
	"./CRO.png": "01c4",
	"./DASH.png": "8434",
	"./DCR.png": "9524",
	"./DECRED.png": "2b21",
	"./DODO.png": "0fa88",
	"./DOGE.png": "c6d7",
	"./DOGE_COIN.png": "bf98",
	"./DOT.png": "d491",
	"./EGLD.png": "16fe",
	"./ELROND.png": "624b",
	"./EOS.png": "915b",
	"./ETC.png": "d5ac",
	"./ETH.png": "f04c",
	"./ETHEREUM.png": "539a",
	"./FANTOM.png": "8a8c",
	"./FIL.png": "0484",
	"./FILE_COIN.png": "faaf",
	"./FLOW.png": "35bd",
	"./FTM.png": "84f1",
	"./FTT.png": "e62c",
	"./FTX.png": "3f98",
	"./GRT.png": "1e43",
	"./HARMONY_ONE.png": "d3b2",
	"./HOLO.png": "7f1f",
	"./HOT.png": "3c38",
	"./HT.png": "295b",
	"./LEO.png": "88f0",
	"./LINK.png": "f047",
	"./LITE.png": "0e96",
	"./LITE_COIN.png": "454e",
	"./LTC.png": "ee08",
	"./LUNA.png": "950e",
	"./MATIC.png": "8339",
	"./MATIC1.png": "6ed2",
	"./MIOTA.png": "1151",
	"./MONERO.png": "6df0",
	"./NEM.png": "4e82a",
	"./NEO.png": "b189",
	"./ONE.png": "f63c",
	"./ONE_INCH.png": "7ecc",
	"./POLKADOT.png": "5b9e",
	"./QTUM.png": "29bd",
	"./REEF.png": "6a71",
	"./REEF_FINANCE.png": "da8e",
	"./RIPPLE.png": "6eeb",
	"./SHIB.png": "88ca",
	"./SHIBA_INU.png": "257e",
	"./SNX.png": "ab90",
	"./SOL.png": "cce7",
	"./SOLANA.png": "4dbc",
	"./STELLAR.png": "f152",
	"./SUSHI.png": "c953",
	"./SYNTHETIX.png": "40da",
	"./TERRA.png": "6743",
	"./TETHER.png": "437c",
	"./TEZOS.png": "8e08",
	"./THE_GRAPH.png": "5086",
	"./TOMAN.png": "f622",
	"./TOMO.png": "916e",
	"./TOMO_CHAIN.png": "e169",
	"./TRON.png": "0469",
	"./TRX.png": "55a4",
	"./UNI.png": "39f7",
	"./UNI_SWAP.png": "b4b3",
	"./USDT.png": "2fdd",
	"./VECHAIN.png": "d45b",
	"./VET.png": "11c3",
	"./VE_CHAIN.png": "0f41",
	"./WAVES.png": "3b03",
	"./XEM.png": "fc84",
	"./XLM.png": "d760",
	"./XMR.png": "ad06",
	"./XRP.png": "c6be",
	"./XTZ.png": "17f8",
	"./ZEC.png": "5963",
	"./ZIL.png": "ed28",
	"./ZILLIQA.png": "9441",
	"./Z_CASH.png": "299b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "569c";